import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import * as CONFIG from 'constants/config';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import Select from 'components/Select';
import UserItem from 'pages/UsersPage/UserItem';
import { AuthContext } from 'AuthProvider';

import { getUsersList } from 'backend/User';

const UsersPage = () => {
  const [selectedProviderValue, setSelectedProviderValue] = useState('all');
  const [selectedLanguageValue, setSelectedLanguageValue] = useState('all');
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const lang = getLanguage();
  const emailProvidersList = [
    {
      alias: 'apple',
      name: {
        ru: 'Apple'
      }
    },
    {
      alias: 'google',
      name: {
        ru: 'Google'
      }
    },
    {
      alias: 'facebook',
      name: {
        ru: 'Facebook'
      }
    },
  ];

  const languagesList = [
    {
      alias: 'en',
      name: {
        ru: 'EN'
      }
    },
    {
      alias: 'es',
      name: {
        ru: 'ES'
      }
    },
    {
      alias: 'it',
      name: {
        ru: 'IT'
      }
    },
    {
      alias: 'pl',
      name: {
        ru: 'PL'
      }
    },
    {
      alias: 'pt',
      name: {
        ru: 'PT'
      }
    },
    {
      alias: 'ru',
      name: {
        ru: 'RU'
      }
    },
    {
      alias: 'uk',
      name: {
        ru: 'UK'
      }
    },
  ];

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    getUsersList()
      .then((result) => {
        setTotalUsers(result.length);
        const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
        setPages(countPages);

        setUsers(getUsersByPage(result));
      })
      .catch((error) => {
        console.log('error', error);
        setUsers([]);
      });
  }, [currentPage]);


  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const getUsersByPage = (items) => {
    let result = [];
    let i = 0;
    const fromPage = (currentPage - 1) * CONFIG.COUNT_PER_PAGE;
    const toPage = currentPage * CONFIG.COUNT_PER_PAGE;
    items.map((element) => {
      if (i >= fromPage && i < toPage) {
        result.push(element);
      }
      i++;
    })

    return result;
  };

  let pageBlock = [];
  if (pages > 1) {
    let arr = [];
    for (let i = 1; i <= pages; i++) {
      arr.push({page: i});
    }
    pageBlock = arr.map((element) => {
      if (currentPage === element.page) {
        return <button className="btn btn-light active" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      } else {
        return <button className="btn btn-light" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      }
    });
  }

  const selectEmailProvider = (value) => {
    setSelectedProviderValue(value);
    getUsersList()
      .then((result) => {
        let cnt = 0;
        if (value !== 'all') {
          let arr = [];
          result.map((element) => {
            if (element.emailProvider === value) {
              cnt++;
              arr.push(element)
            }
          });
          const countPages = Math.ceil(arr.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setUsers(getUsersByPage(arr));
          setCurrentPage(1);
          setTotalUsers(cnt);
        } else {
          setTotalUsers(result.length);
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setUsers(getUsersByPage(result));
        }
      })
      .catch((error) => {
        console.log('error', error);
        setUsers([]);
      });
  };

  const selectLanguage = (value) => {
    setSelectedLanguageValue(value);
    getUsersList()
      .then((result) => {
        let cnt = 0;
        if (value !== 'all') {
          let arr = [];
          result.map((element) => {
            if (element.language === value) {
              cnt++;
              arr.push(element)
            }
          });
          const countPages = Math.ceil(arr.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setUsers(getUsersByPage(arr));
          setCurrentPage(1);
          setTotalUsers(cnt);
        } else {
          setTotalUsers(result.length);
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setUsers(getUsersByPage(result));
        }
      })
      .catch((error) => {
        console.log('error', error);
        setUsers([]);
      });
  };

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="users" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Пользователи</li>
              </ul>
            </div>
            <div className="page-content">
            <div className="row">
						  	<div className="col-xs-12 text-right">
                  <b>Всего пользователей:</b> {totalUsers}
                </div>
              </div>
              <div className="row">
						  	<div className="col-xs-12">
								  <table id="simple-table" className="table  table-bordered table-hover">
									  <thead>
                          <tr>
                            <th>#</th>
                            <th>UID</th>
                            <th>Картинка</th>
                            <th>E-mail</th>
                            <th>
                              Провайдер
                              <br />
                              <Select
                                items={emailProvidersList}
                                placeholder="Провайдер"
                                withAll={true}
                                onChange={(event) => selectEmailProvider(event.target.value)}
                                selectedValue={selectedProviderValue}
                              />
                            </th>
                            <th>Полное имя (Логин)</th>
                            <th>
                              Язык
                              <br />
                              <Select
                                items={languagesList}
                                placeholder="Язык"
                                withAll={true}
                                onChange={(event) => selectLanguage(event.target.value)}
                                selectedValue={selectedLanguageValue}
                              />
                            </th>
                            <th>
                              Дата регистрации
                              <br />
                              Дата обновления
                            </th>
                            <th></th>
                          </tr>
										</thead>
										<tbody>
                          {users.map((element, index) => {
                            return (<UserItem
                              user={element}
                              key={index}
                              index={index}
                              currentPage={currentPage}
                            />);
                          })}
                    </tbody>
								  </table>
                  <div className="btn-group">
                    {pageBlock}
                  </div>
								</div>
						  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersPage;
